module.exports = __webpack_public_path__ + "static/media/icon_services_off.3ee47b9f.png";